/* eslint-disable jira/filename-case */

import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { GetJSWReportsResponse } from './types.tsx';

export const fetchJSWReports = (boardId: string | number): Promise<GetJSWReportsResponse> => {
	if (boardId == null) {
		throw new Error('invalid boardId');
	}
	return performGetRequest(`/rest/agile/latest/board/${boardId}/reports`);
};
